import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import { recordKind } from '../components/records/recordKinds';
import { coverageExpandRow } from '../components/workflow/CoverageDisplay';
import useEngagementListFilters from '../components/shared/useEngagementListFilters';
import { formatDateShort } from '../utils/dateFormat';

// Management — Signed Financial Statements / QC35 的正式記錄清單
// （docs/modules/engagement-records.md）。
//
// 這幾張卡直接用 workflow 的 `WorkflowListShell`，不是抄一份外觀。清單信封
// （data + total）、搜尋、伺服器端排序分頁、空狀態全部沿用同一支元件。
//
// 一個頁面吃多種 kind（現為 fs／qc35），欄位定義來自
// components/records/recordKinds——那份設定
// 同時餵這頁、詳情頁與建立/編輯表單。頁面自己不持有 KINDS。
const QMEngagementRecords = () => {
  const { kind } = useParams();
  const { hasPermission } = useAuth();
  const cfg = recordKind(kind);
  // 篩選列與 Engagements 頁同一套；記錄涵蓋到任一件符合的案就列出。Status
  // 晶片預設不勾——記錄大多掛在已完成的案上，照 show_by_default 會幾乎全被藏掉。
  const engFilters = useEngagementListFilters({
    optionsPath: `/api/qm/engagement-records/${kind}/filter-options`,
    statusDefault: 'none',
  });
  if (!cfg) return <Navigate to="/manage" replace />;
  if (!engFilters.ready) return <p className="text-center text-sm text-slate-500 mt-8">Loading…</p>;

  return (
    <WorkflowListShell
      title={cfg.title}
      subtitle={cfg.subtitle}
      backTo="/manage"
      backLabel="Management"
      // 手動建立：沒走過流程的舊案在這裡補記錄,建完立刻
      // 回寫 engagement 主檔。
      canCreate={hasPermission('engagements:edit')}
      newTo={`${cfg.listTo}/new`}
      newLabel="New Record"
      showHideCompleted={false}
      apiPath={`/api/qm/engagement-records/${kind}`}
      extraParams={engFilters.params}
      rowTo={(r) => `${cfg.listTo}/${r.id}`}
      searchPlaceholder={cfg.searchPlaceholder}
      defaultSort={{ key: 'createdAt', direction: 'desc' }}
      emptyText={cfg.emptyText}
      toolbarTop={engFilters.statusChips}
      filters={engFilters.selects}
      columns={[
        ...cfg.columns,
        {
          key: 'createdAt',
          label: 'Recorded',
          sortKey: 'createdAt',
          render: (r) => <span className="text-slate-500">{formatDateShort(r.createdAt)}</span>,
        },
      ]}
      expandRow={cfg.coverage ? coverageExpandRow : null}
    />
  );
};

export default QMEngagementRecords;
